
const InnovationSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            💡 Innovation Through Collaboration
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            At Golden Black, innovation is our foundation. We believe that every challenge 
            deserves a unique, science-based solution.
          </p>
        </div>

        {/* Manufacturing Facilities Section */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              🏭 Our Manufacturing Excellence
            </h3>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              State-of-the-art production facilities where our expert engineers design and manufacture 
              high-quality chemical solutions under the Golden Black brand.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            <div className="bg-gray-50 rounded-lg overflow-hidden shadow-lg">
              <img 
                src="https://public.readdy.ai/ai/img_res/501ff9edfc878fd1114fdc88775572a8.jpg"
                alt="Golden Black Chemical Manufacturing Facility"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-2">Production Facility</h4>
                <p className="text-gray-600">Advanced reactors and mixing systems for custom chemical formulations</p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg overflow-hidden shadow-lg">
              <img 
                src="https://readdy.ai/api/search-image?query=Chemical%20laboratory%20with%20scientists%20in%20white%20coats%20testing%20and%20analyzing%20chemical%20samples%2C%20Golden%20Black%20logo%20visible%20on%20equipment%2C%20advanced%20analytical%20instruments%20and%20quality%20control%20testing%20stations%2C%20professional%20research%20and%20development%20environment%20with%20beakers%20and%20testing%20apparatus&width=400&height=300&seq=manufacturing2&orientation=landscape"
                alt="Golden Black Quality Control Laboratory"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-2">Quality Control Lab</h4>
                <p className="text-gray-600">Rigorous testing and analysis ensuring product excellence</p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg overflow-hidden shadow-lg">
              <img 
                src="https://readdy.ai/api/search-image?query=Industrial%20chemical%20packaging%20and%20bottling%20line%20with%20Golden%20Black%20branded%20containers%20and%20labels%2C%20automated%20filling%20systems%20and%20quality%20packaging%20equipment%2C%20workers%20ensuring%20proper%20labeling%20and%20sealing%20of%20chemical%20products%20in%20clean%20manufacturing%20environment&width=400&height=300&seq=manufacturing3&orientation=landscape"
                alt="Golden Black Packaging Operations"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-2">Packaging & Distribution</h4>
                <p className="text-gray-600">Professional packaging and distribution of finished products</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Our Collaborative Process
            </h3>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-search-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">Understand Challenges</h4>
                  <p className="text-gray-600">We work closely with clients to identify operational bottlenecks and specific requirements.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-flask-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">Simulate & Test</h4>
                  <p className="text-gray-600">Advanced laboratory and field testing to validate chemical performance and compatibility.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-tools-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">Custom Formulation</h4>
                  <p className="text-gray-600">Design cost-effective, sustainable solutions tailored to specific operational needs.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-check-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">Real-World Validation</h4>
                  <p className="text-gray-600">Performance validation through actual field application and continuous optimization.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Team%20of%20chemical%20engineers%20in%20Golden%20Black%20branded%20uniforms%20collaborating%20in%20modern%20laboratory%2C%20diverse%20group%20of%20professionals%20working%20together%20on%20chemical%20formulations%2C%20advanced%20research%20equipment%20and%20collaborative%20workspace%20with%20Golden%20Black%20company%20branding%20visible&width=600&height=500&seq=collaboration&orientation=portrait"
              alt="Golden Black Engineering Team Collaboration"
              className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnovationSection;
